import React from 'react';

import { LIVE_PAGE_SESSION_EXPERIENCE, ExperienceStart } from '@confluence/experience-tracker';
import { getLivePageEditExperienceName } from '@confluence/experience-tracker/entry-points/livePageExperiences';
import { getLivePageViewExperienceName } from '@confluence/experience-tracker/entry-points/livePageExperiences';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled';

const livePageSessionCollect = (events, experience) => {
	const livePageEditExperienceName = getLivePageEditExperienceName();
	const livePageViewExperienceName = getLivePageViewExperienceName();
	const liveEditExperienceFailed = events.find(
		({ action, name }) => action === 'taskFail' && name === livePageEditExperienceName,
	);
	const liveEditExperienceAborted = events.find(
		({ action, name }) => action === 'taskAbort' && name === livePageEditExperienceName,
	);
	const liveViewExperienceFailed = events.find(
		({ action, name }) => action === 'taskFail' && name === livePageViewExperienceName,
	);
	const liveViewExperienceAborted = events.find(
		({ action, name }) => action === 'taskAbort' && name === livePageViewExperienceName,
	);

	if (liveEditExperienceFailed || liveViewExperienceFailed) {
		experience.fail({
			error: new Error(`Live page ${liveViewExperienceFailed ? 'view' : 'edit'} experience failed`),
		});
	} else if (liveEditExperienceAborted || liveViewExperienceAborted) {
		experience.abort({
			reason: `Live page ${liveViewExperienceAborted ? 'view' : 'edit'} experience aborted`,
		});
	}
};

export function LivePageSessionExperienceStart() {
	const { livePageReleasePhase } = useIsLivePagesFeatureEnabled();
	return (
		<ExperienceStart
			name={LIVE_PAGE_SESSION_EXPERIENCE}
			collect={livePageSessionCollect}
			// isLivePage is a necessary attribute because we check for this attribute when attempting to succeed
			// the live-page-session experience prior to route transition in startExperienceForRoute.ts
			attributes={{ livePageReleasePhase, isLivePage: true }}
		/>
	);
}
